<div>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancelDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Schedule absence</h4>
  </div>
  <form class="form-group modal-body" #absenceForm="ngForm" appDateRangeValidator startDateControl="startDate" endDateControl="endDate">
    <app-layout-row>
      <app-layout-column [width]="6">
        <app-datetimebox decorator datetime name="startDate" caption="Start date" [ngModel]="absenceStart()" required [calculateValidationText]="getStartDateValidationText">
        </app-datetimebox>
      </app-layout-column>
      <app-layout-column [width]="6">
        <app-datetimebox decorator datetime name="endDate" caption="End date" [ngModel]="absenceEnd()" appFutureDateValidator required [calculateValidationText]="getEndDateValidationText">
        </app-datetimebox>
      </app-layout-column>
    </app-layout-row>
    <app-layout-row>
      <app-layout-column [width]="12">
        <app-textbox decorator name="note" caption="Note" [ngModel]="absenceNote()">
        </app-textbox>
      </app-layout-column>
    </app-layout-row>

    <p class="mt-2">All alerts are suspended during the selected period and will not trigger any actions. Alerts are
      triggered and processed as usual outside the selected absence period.</p>
  </form>
  <div class="modal-footer">
    <div class="button-container">
      <app-button primary submit class="button-item-1" width="100%" [disabled]="absenceForm.invalid" (buttonClick)="setAbsense(absenceForm)">Set absence</app-button>
      <app-button secondary class="button-item-2" width="100%" (buttonClick)="cancelDialog()">Close</app-button>
      @if (isAbsenceScheduled()) {
      <app-button secondary class="button-item-3" width="100%" (buttonClick)="cancelAbsence()">Cancel absence</app-button>
      }
    </div>
  </div>
</div>
